import { IRedeemCodeCreateRequestDto } from '../types';
import settings from '../settings';
import api from './base';

export function createRedeemCode(payload: IRedeemCodeCreateRequestDto) {
  const uri = `${settings.getApiURI()}/redeem/v1/redeem-codes`;
  return api.http.post(uri, payload);
}

export function deactiveRedeemCodeById(id: number) {
  const uri = `${settings.getApiURI()}/redeem/v1/redeem-codes/${id}`;
  return api.http.delete(uri);
}

export function updateRedeemCodeById(id: number, title: string, count: number) {
  const uri = `${settings.getApiURI()}/redeem/v1/redeem-codes/${id}`;
  return api.http.patch(uri, { title, count });
}

export function getRedeemCodes(filter: 'all' | 'active' | 'deactive', page = 1, limit = 15) {
  let uri = `${settings.getApiURI()}/redeem/v1/redeem-codes/list?page=${page}&limit=${limit}`;

  if (filter === 'active') {
    uri += `&valid=true`;
  } else if (filter === 'deactive') {
    uri += `&valid=false`;
  }

  return api.getWithCancel(uri);
}
